import { render, staticRenderFns } from "./AddSubtags.vue?vue&type=template&id=3eedf79e&scoped=true&"
import script from "./AddSubtags.vue?vue&type=script&lang=js&"
export * from "./AddSubtags.vue?vue&type=script&lang=js&"
import style0 from "./AddSubtags.vue?vue&type=style&index=0&id=3eedf79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eedf79e",
  null
  
)

export default component.exports